module.exports = __webpack_public_path__ + "static/img/3-2.d251a24a.png";